import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import { AuthService } from "app/login/services/auth.service";
import { Subscription } from "app/shared/models/subscription";
import { BillingService } from "app/shared/services/billing.service";
import { BillingDetails } from "app/shared/models/billing-details";
import { SubscriptionStatus } from "app/shared/models/subscription-status";
import { HTTPService } from "app/shared/services/http.service";
import { SystemError } from "app/shared/models/SystemError";
import { ErrorCode } from "app/shared/models/ErrorCodes";
import { SubscriptionHydratorService } from "app/shared/services/subscription-hydrator.service";

@Injectable()
export class SubscriptionService {

    private _subscriptionRequiredSubject:Subject<boolean>;
    constructor(private authService:AuthService,
        private billingService:BillingService
        ,private httpService:HTTPService
        , private subHydrator:SubscriptionHydratorService) {
        this._subscriptionRequiredSubject = new Subject<boolean>();
    }


  cancelSubscription(subscription:Subscription, billingDetails:BillingDetails, reason:string) {
    let subIndex = billingDetails.subscriptions.findIndex(s => s.id == subscription.id);
    let sub = billingDetails.subscriptions[subIndex];
    let subscriptionToSave:any = Object.assign({}, sub);
    subscriptionToSave.status = SubscriptionStatus.CANCEL_PROCESSING;
    subscriptionToSave.cancelReason = reason;

    return this.authService.getCurrentUser().then(user => {
      return this.httpService.post("/admin/billing/" + user.companyID + "/subscription/" + subscriptionToSave.id, subscriptionToSave)
      .then((resp) => {
        let json = resp.json() as any;
        let updatedSubscription = this.subHydrator.fromJSONObject(json);
        billingDetails.subscriptions[subIndex] = updatedSubscription;
        this.authService.updateUserWithSubscription(updatedSubscription);
        return billingDetails;
      })
      .catch(error => {
        console.error(error);
        if (error.status < 500) {
          let errorResponse = error.json() as any;
          throw new SystemError(errorResponse._code, errorResponse._message);
        } else {
          throw new SystemError(ErrorCode.SYSTEM_ERROR, "There was a system error in communicating with the server");
        }
      })
    });
  }

    public upgradeSubscription(subscription:Subscription, billingDetails:BillingDetails) {
        // subscription.status = SubscriptionStatus.ACTIVE; // just fake it for now.

        let subIndex = billingDetails.subscriptions.findIndex(s => s.id == subscription.id);
        let sub = billingDetails.subscriptions[subIndex];
        let subscriptionToSave = Object.assign(new Subscription(), sub);
        subscriptionToSave.status = SubscriptionStatus.ACTIVE;
        return this.authService.getCurrentUser().then(user => {
          return this.httpService.post("/admin/billing/" + user.companyID + "/subscription/" + subscriptionToSave.id, subscriptionToSave)
          .then((resp) => {
            let json = resp.json() as any;
            let updatedSubscription = this.subHydrator.fromJSONObject(json);
            this.authService.updateUserWithSubscription(updatedSubscription);
            billingDetails.subscriptions[subIndex] = updatedSubscription;
            return billingDetails;
          })
          .catch(error => {
            // TODO: stephen should we put this in the HTTP service?  It would be nice to start having the same objects on the server
            // as we do on the client.
            console.error(error);
            if (error.status < 500) {
              let errorResponse = error.json() as any;
              throw new SystemError(errorResponse._code, errorResponse._message);
            } else {
              throw new SystemError(ErrorCode.SYSTEM_ERROR, "There was a system error in communicating with the server");
            }
          });
        });
    }

    public updatePastDueSubscription(subscription:Subscription, billingDetails:BillingDetails) {
        // poll the server and check if the subscription has been processed...
      return new Promise<BillingDetails>((resolve, reject) => {
        let count = 0;
        let interval = setInterval(() => {
          if (count++ > 10) {
            // we got nowhere...
            clearInterval(interval);
            resolve(billingDetails);
            return;
          }
           // too tired, but something like this would work...
           this.billingService.getBillingDetails().then(details => {
            let updatedSub = details.subscriptions.find(s => s.id == subscription.id);
            if (updatedSub && updatedSub.isActiveSubscription()) {
                this.authService.updateUserWithSubscription(updatedSub);
                clearInterval(interval);
                resolve(details);
            }
          })
          .catch(error => {
              reject(error);
          });
        }, 2000)
      });
    }

    public subscriptionRequiredEvent() : Observable<boolean> {
        return this._subscriptionRequiredSubject;
    }

    public getSubscriptionPageRoute() : string[] {
        return ['/admin/my-account/plans'];
    }

    public notifySubscriptionRequired() {
        this._subscriptionRequiredSubject.next(true);
    }

    public getCurrentUserSubscription() {
        return this.authService.getCurrentUser().then(user => {
            return user.subscription;
        });
    }

    public getPlanDetailsForSubscription(subscription:Subscription) {
        let items = [];
        if (subscription.plan && subscription.plan.unitType == 'Assessments') {
            items.push("5000 Assessments per month");
            items.push("$1 per additional thousand tests");
            items.push("External hosting of assessments");
            items.push("Custom hosted assessment reports");
          } else {
            items.push("Unlimited use of our library of research backed, valid, and reliable assessments");
            items.push("Comprehensive and personalized battery and assessment reports")
            items.push("Unlimited number of clients");
            items.push("Unlimited number of assessment batteries");
            items.push("Unlimited number of assessments");
            items.push("Assignment completion notifications");
          }
        return items;
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/services/subscription.service.ts